import { sbGetSetting } from "./supabaseClient";

// PIN-based authentication - loads from Supabase
const FALLBACK_PIN = "123456"; // Fallback if not in database

export const verifyAdminPin = async (pin) => {
  try {
    // Try to get PIN from Supabase first
    let dbPin;
    try {
      dbPin = await sbGetSetting("origamic-admin-pin");
    } catch (err) {
      console.warn("Could not load PIN from database, using fallback");
    }

    const validPin = dbPin || FALLBACK_PIN;
    return pin === validPin;
  } catch (err) {
    console.error("Error verifying PIN:", err);
    // Fall back to hardcoded PIN on error
    return pin === FALLBACK_PIN;
  }
};

export const isAuthenticated = () => {
  return localStorage.getItem("auth_token") === "true";
};

export const setAuthenticated = (value = true) => {
  if (value) {
    localStorage.setItem("auth_token", "true");
  } else {
    localStorage.removeItem("auth_token");
  }
};

export const clearAuth = () => {
  localStorage.removeItem("auth_token");
};
